import { Link } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function BookingCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <Card className="card-marketing max-w-md w-full">
        <CardContent className="p-8 text-center">
          <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
          <h1 className="font-heading text-2xl text-text-primary mb-4">Booking Cancelled</h1>
          <p className="text-text-secondary mb-8">
            Your booking was cancelled. No charges were made to your card.
          </p>
          <div className="space-y-4">
            <Link to="/booking">
              <Button className="btn-primary w-full" data-testid="try-again-btn">
                Try Again
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="btn-secondary w-full" data-testid="return-home-btn">
                Return to Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
